import { Stack, Typography, useTheme } from "@mui/material";
import { ScrollWithShadows } from "components/layout/utils/ScrollWithShadows";
import { T } from "components/util/t";
import { Section } from "./HomePage";
import { useRecentlyViewed } from "./useRecentlyViewed";
import { Sx } from "utils/sx";
import { RecentlyViewedItem } from "./useRecentlyViewed";
import { RecentlyViewedEventCard } from "./RecentlyViewedEventCard";
import { RecentlyViewedEventDivisionCard } from "./RecentlyViewedEventDivisionCard";
import { RecentlyViewedRankingsCard } from "./RecentlyViewedRankingsCard";
import { EVENT_CARD_WIDTH } from "./eventCard/EventCard";
import { useIsMobile } from "hooks/useIsMobile";


const RECENT_ITEM_CARD_WIDTH = 55;
const RECENT_ITEM_CARD_SPACING = 1;

const sectionStyle: Sx = (theme) => ({
    marginTop: theme.spacing(6)
});

const recentCardStyle: Sx = (theme) => ({
    width: theme.spacing(RECENT_ITEM_CARD_WIDTH),
    [theme.breakpoints.down("md")]: {
        width: theme.spacing(EVENT_CARD_WIDTH)
    }
});

export const RecentlyViewed: React.FC = () => {
    const theme = useTheme();
    const isMobile = useIsMobile();
    const { items: recentlyViewed } = useRecentlyViewed();

    if (recentlyViewed.length === 0) return null;

    const cardWidth = parseInt(theme.spacing(isMobile ? EVENT_CARD_WIDTH : RECENT_ITEM_CARD_WIDTH));
    const cardGap = parseInt(theme.spacing(RECENT_ITEM_CARD_SPACING));
    const cardWidthWithGap = cardWidth + cardGap;

    return(
        <Section sx={sectionStyle}>
            <Typography variant="h3" component="h3" sx={(theme) => ({ marginBottom: theme.spacing(2), paddingX: theme.spacing(2) })}>
                <T>Recently viewed</T>
            </Typography>
            <ScrollWithShadows shadowsColor="background.default" showButtons buttonsPositionAbsolute fixedScrollOffset={cardWidthWithGap}>
                <Stack sx={(theme) => ({ gap: theme.spacing(RECENT_ITEM_CARD_SPACING), paddingX: theme.spacing(2), alignItems: "start" })} direction="row">
                    {recentlyViewed.map((item, index) =>
                        <RecentlyViewedItemCard item={item} key={index} sx={recentCardStyle} />
                    )}
                </Stack>
            </ScrollWithShadows>
        </Section>
    );
};

type TypeToCards = {
    [key in RecentlyViewedItem["type"]]: React.FC<any>;
};

const cardComponents: TypeToCards  = {
    event: RecentlyViewedEventCard,
    eventDivision: RecentlyViewedEventDivisionCard,
    rankings: RecentlyViewedRankingsCard
};

const RecentlyViewedItemCard: React.FC<{item: RecentlyViewedItem, sx?: Sx}> = ({ item, sx }) => {
    const Card = cardComponents[item.type];
    return <Card type={item.type} item={item} sx={sx} />;
};
